<template>
  <div>
    <router-view/>
    <app-toast></app-toast>
  </div>
</template>

<script>

export default {
  name: 'App',
  created () {
    window.addEventListener('beforeunload', this.handler)
    this.$au.onAuthStateChanged(user => {
      if (user)
        this.$store.dispatch('usuario/auto', {email: user.email, uid: user.uid})
    })
    // console.log(process.env.NODE_ENV)
  },
  computed: {
    user () {
      return this.$store.getters['usuario/user']
    }
  },
  methods: {
    handler () {
      this.$store.dispatch('usuario/disconnect', this.user.uid)
    }
  }
}
</script>


